<template>
  <base-modal title="Forfeit Deposit" body-class="is-paddingless">
    <div class="columns is-multiline p-2">
      <div class="column is-12">
        <p>{{ deposit.forfeit_reason }}</p>
      </div>
    </div>
    <div slot="footer" class="buttons"></div>
  </base-modal>
</template>

<script>
export default {

  props: {
    payload: Object
  },

  data:() => ({
    deposit: {}
  }),

  created() {
    this.deposit = { ...this.payload }
  },

}
</script>